module.exports = __webpack_public_path__ + "static/media/TITAN-ASIA-VARIANTE-ombre.60b1f265.png";